// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T22:33:47.673Z
// Property: The Verge (ID: 6767906449164271)
// Collections: 43 amenities, 30 floorplans (live), 32 photos, 28 POIs, 5 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162415",
  "multihub_property_id": "6767906449164271",
  "property_external_id": "1253707",
  "property_zillow_url": "https://www.zillow.com/apartments/auburn-wa/the-verge/CgKKpr/",
  "property_apartments_url": "https://www.apartments.com/the-verge-auburn-wa/bdbeyhc/",
  "property_google_business_url": "https://www.google.com/maps?cid=8121617155603798596",
  "property_linkedin_url": null,
  "property_hubspot_id": "5641873213",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-verge",
  "property_name": "The Verge",
  "property_website_url": "https://www.thevergeauburn.com",
  "property_domain": "https://www.thevergeauburn.com",
  "property_address": "109 South Division St",
  "property_full_address": "109 S Division St, Auburn, WA 98001",
  "property_address_1": "109 S Division St",
  "property_address_2": null,
  "property_address_city": "Auburn",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98001",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": null,
  "property_address_latitude": "47.3060464",
  "property_address_longitude": "-122.2304733",
  "property_email": "info@thevergeauburn.com",
  "property_phone": "(253) 275-0008",
  "property_call_tracking_phone": "833-521-1870",
  "property_company_name": "Pillar Properties",
  "property_company_url": "https://www.pillarproperties.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At The Verge in Auburn, your ideal living space awaits! Choose from stylish studio, one, or two-bedroom floor plans featuring modern quartz countertops and custom cabinets. Enjoy top-notch amenities like resident package lockers, a car wash, and a Paw Spa. Find your new home today—browse availability or schedule a tour!",
  "property_long_description": "The Verge is perfectly situated - close to the Sounder Transit Station, shopping, dining and entertainment. Easy commute to downtown Seattle and the Seattle Tacoma International Airport and close to Green River Community College, the MultiCare Auburn Medical Center, The Outlet Collection and the Interurban Trail.With sweeping views of Mount Rainier, the mountain looks so close, it feels like you could almost reach out and touch it. Featuring a Walk Score of 87, The Verge is an easy stroll to a variety of restaurants and retail. The spacious apartments at The Verge feature high end finishes, tall ceilings, large kitchens and bathrooms, private patios along with an expansive rooftop deck, huge fitness center and private work from home amenity spaces.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
    "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
    "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
    "width": 2560,
    "height": 1702
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "226",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.01769911504425",
  "property_admin_fee": "300",
  "property_application_fee": "45",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "180",
  "property_pet_restrictions": "No aggressive breeds. Breed and weight restrictions may apply. Maximum 3 pets per unit.",
  "property_pet_policy_description": "Allow 2 pets, no weight limit and no breed restrictions.  Pet Deposit: $375/pet  Pet Rent: $50/month/pet",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://thevergeauburn.securecafe.com/onlineleasing/109-south-division-st-auburn-wa-98801/floorplans.aspx",
  "property_resident_portal_url": "https://thevergeauburn.securecafenet.com/residentservices/109-south-division-st-auburn-wa-98801/userlogin",
  "property_apply_now_url": "https://thevergeauburn.securecafe.com/onlineleasing/109-south-division-st-auburn-wa-98801/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d6cdd-7fff-7243-b32e-a09f4db37bcc.webp",
  "property_primary_logo_media": {
    "alt_text": "The Verge logo",
    "public_id": "019d6cdd-7fff-7243-b32e-a09f4db37bcc",
    "storage_key": "property/6767906449164271/019d6cdd-7fff-7243-b32e-a09f4db37bcc.webp",
    "width": 1292,
    "height": 330
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019db501-bd79-739d-b5e7-3ebd51d372a7.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Verge logo with a blue circle and white V shape.",
    "public_id": "019db501-bd79-739d-b5e7-3ebd51d372a7",
    "storage_key": "property/6767906449164271/019db501-bd79-739d-b5e7-3ebd51d372a7.webp",
    "width": 807,
    "height": 848
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019db501-feac-7398-91ad-cc3fc660dad6.webp",
  "property_icon_media": {
    "alt_text": "The V by Vox Communities logo, a white stylized 'V' inside a blue circle.",
    "public_id": "019db501-feac-7398-91ad-cc3fc660dad6",
    "storage_key": "property/6767906449164271/019db501-feac-7398-91ad-cc3fc660dad6.webp",
    "width": 222,
    "height": 225
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019db501-feac-7398-91ad-cc3fc660dad6.webp",
  "property_fav_icon_media": {
    "alt_text": "The V by Vox Communities logo, a white stylized 'V' inside a blue circle.",
    "public_id": "019db501-feac-7398-91ad-cc3fc660dad6",
    "storage_key": "property/6767906449164271/019db501-feac-7398-91ad-cc3fc660dad6.webp",
    "width": 222,
    "height": 225
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d6cde-5f04-705a-83ff-8a37ee2d8233.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d6cde-5f04-705a-83ff-8a37ee2d8233",
    "storage_key": "property/6767906449164271/019d6cde-5f04-705a-83ff-8a37ee2d8233.webp",
    "width": 1280,
    "height": 340
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d6cde-2b6f-7079-854d-b545345c148f.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d6cde-2b6f-7079-854d-b545345c148f",
    "storage_key": "property/6767906449164271/019d6cde-2b6f-7079-854d-b545345c148f.webp",
    "width": 1280,
    "height": 340
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d06cf-26f9-7551-948c-1245b11c8422.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
  "property_company_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc2-1eb8-7554-8d89-d3424651cf63",
    "storage_key": "company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
    "width": 189,
    "height": 128
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-9029-7028-b531-c3ae9dacde22",
    "storage_key": "company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
    "width": 178,
    "height": 122
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-00d2-7093-a184-b3de0f0bba5a",
    "storage_key": "company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
    "width": 178,
    "height": 122
  },
  "property_primary_color": "#1983b2",
  "property_secondary_color": "#303638",
  "property_font_color": "#303638",
  "property_color_4": "#e86662",
  "property_color_3": "#f8c115",
  "property_color_5": "#acced5",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "484 - 1198",
  "property_sqft_min": "484",
  "property_sqft_max": "1198",
  "property_price_range": "1692 - 3597",
  "property_price_min": "1692",
  "property_price_max": "3597",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/thevergeauburn",
  "property_instagram_url": "https://www.instagram.com/thevergeauburn",
  "property_twitter_url": "https://x.com/thevergeauburn",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ80wNc3NZkFQRRJp72cXHtXA",
  "property_youtube_url": "https://www.youtube.com/watch?t=600&v=p7exFJWnMGw",
  "property_yelp_url": "https://www.yelp.com/biz/the-verge-auburn",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Verge",
  "property_home_romance_title": "Embrace Your New Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "At The Verge in Auburn, your ideal living experience awaits. Enjoy vibrant rooftop gatherings with breathtaking views of Mount Rainier, unwind in our inviting courtyard, or challenge friends in the two-level lounge. Our chic apartments feature high-end finishes and thoughtful amenities designed for ultimate comfort and convenience.",
  "property_home_floorplans_blurb": "Elevate your lifestyle at The Verge in Auburn, where modern living meets comfort. Choose from thoughtfully designed studio, one-bedroom, and two-bedroom floor plans, tailored to suit your needs. Each apartment invites you to enjoy a vibrant community. Browse available homes today and find your ideal sanctuary in Auburn!",
  "property_home_gallery_blurb": "At The Verge in Auburn, each stylish apartment, from cozy studios to spacious two-bedrooms, boasts high-end finishes and scenic views. Relax in the rooftop lounge with breathtaking vistas of Mount Rainier, or unwind in our state-of-the-art fitness center. Picture yourself living here, where comfort meets community.",
  "property_home_neighborhood_blurb": "At The Verge in Auburn, your perfect living space awaits with thoughtfully designed one-bedroom, studio, and two-bedroom floor plans. Nestled in a vibrant neighborhood, immerse yourself in local favorites and charming hotspots. Check out what our community has to offer and enrich your lifestyle today!",
  "property_home_reviews_blurb": "At The Verge in Auburn, residents rave about their vibrant community, calling it “a perfect blend of comfort and style.” Experience the charm of modern living and exceptional amenities. Curious about what makes us special? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in vibrant Auburn, The Verge offers easy access to recreational gems like Steel Lake Park and the MaST Center Aquarium. Unwind at the Pacific Bonsai Museum or catch a game at Federal Way Memorial Field. Dive into local culture—there's always something exciting around the corner! See what's nearby.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Verge in Auburn, indulge in a lifestyle that blends comfort with convenience. Enjoy modern apartment features like quartz countertops and custom cabinets, alongside exciting amenities such as resident package lockers and a paw spa. Elevate your living experience today—ample opportunities await you and your furry friends!",
  "property_applynow_blurb": "At The Verge in Auburn, your ideal space awaits, whether it's a cozy studio or a spacious two-bedroom. Enjoy modern comforts like quartz countertops and custom cabinets, along with unique amenities like paw spas and car wash facilities. Ready for a fresh start? Find your new home and lease online today!",
  "property_contactus_blurb": "At The Verge in Auburn, you'll find the perfect space tailored to your lifestyle—whether it's a cozy studio, a spacious one-bedroom, or a stylish two-bedroom. Let us help you find your ideal home. Have questions? Contact our leasing team today and take the first step toward your new adventure!",
  "property_faqs_blurb": "At The Verge in Auburn, find your perfect match with our diverse floor plans, including cozy studios and spacious two-bedroom options. Each living space is designed for comfort and style. Have questions? Browse our FAQs page for insights into our community and what makes living here exceptional!",
  "property_floorplans_blurb": "At The Verge in Auburn, choose your ideal living space from stylish studio, spacious one-bedroom, or accommodating two-bedroom layouts. Each floor plan is designed for comfort and functionality. Browse our available apartment homes and discover the perfect blend of modern elegance and vibrant community living today!",
  "property_gallery_blurb": "At The Verge in Auburn, envision life in stylish studio, one, or two-bedroom layouts. Indulge in top-tier amenities like quartz countertops, a Paw Spa, and convenient resident package lockers. Enjoy modern comforts with AC ports and high-speed internet. Picture your vibrant lifestyle—your new home awaits!",
  "property_interactivemap_blurb": "Welcome to The Verge in Auburn, where modern living meets convenience. Our thoughtfully designed floor plans—studio, one, and two-bedroom apartments—feature quartz countertops, custom cabinetry, and high-speed internet. Enjoy unique amenities like resident package lockers, a paw spa, and car charging stations. Use our interactive community map to find your ideal home!",
  "property_pets_blurb": "At The Verge in Auburn, your furry friends are not just allowed; they're celebrated! With spacious apartments and nearby parks, every tail can wag with joy. Enjoy a vibrant community where both you and your pets thrive together in a welcoming atmosphere. Come experience the ultimate pet-friendly lifestyle!",
  "property_referafriend_blurb": "At The Verge in Auburn, our diverse floor plans—ranging from cozy studios to spacious two-bedroom apartments—offer the perfect space for every lifestyle. Great friends make great neighbors, so share the joy of living here! Refer a friend today and elevate your community experience together.",
  "property_residentaccess_blurb": "Welcome to The Verge in Auburn, where your ideal living space awaits—choose from cozy studios, spacious one-bedroom, or versatile two-bedroom floor plans. Enhance your resident experience by accessing our portal for seamless rent payment and maintenance scheduling today! Your comfort and convenience start with us.",
  "property_reviews_blurb": "At The Verge in Auburn, residents praise the vibrant community spirit and welcoming atmosphere, exclaiming, “It feels like home here!” With a rich array of amenities and convenient living options, our apartment community nurtures connection and comfort. Dive into our resident reviews and see why The Verge could be your perfect home!",
  "property_created_at": "1743797426055",
  "property_scheduletour_blurb": "At The Verge in Auburn, choose from thoughtfully designed studio, one, or two-bedroom apartments that fit your lifestyle. Our vibrant community offers a unique blend of comfort and convenience. Schedule a tour today and see what our residents love about calling The Verge home! Your new adventure awaits!",
  "property_thankyou_blurb": "Thank you for reaching out! At The Verge in Auburn, your dream apartment awaits. From cozy studios to spacious two-bedroom layouts, we offer diverse floor plans designed for your lifestyle. Stay tuned—one of our team members will be in touch soon to help make your new home a reality!",
  "property_virtualtours_blurb": "Step inside The Verge in Auburn and envision your next chapter. From stylish studios to spacious two-bedroom layouts, each floor plan is designed for modern living. Ready to find your perfect space? Immerse yourself in our virtual tour today and experience the vibrant community awaiting you!",
  "property_copyright": "2025 All Rights Reserved. The Verge",
  "property_seo_title_home": "The Verge | Apartments & Townhomes in Downtown Auburn",
  "property_seo_description_home": "Experience comfort & convenience at The Verge in Auburn, WA. We offer studio, 1, & 2-bedroom apartments & townhomes for rent in Downtown Auburn!",
  "property_seo_title_floorplans": "Floor Plans | Studio, 1, & 2 Bedroom Apartments & Townhomes",
  "property_seo_description_floorplans": "The Verge offers studio, 1, & 2-bedroom layouts with luxurious comfort in Auburn, WA. Browse our apartments and townhomes for rent now!",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Apartments & Townhomes",
  "property_seo_description_amenities": "The Verge is a community with modern amenities and apartments and townhomes, all conveniently located in Auburn, WA.",
  "property_seo_title_gallery": "Gallery | Apartments & Townhomes for Rent in Auburn, WA",
  "property_seo_description_gallery": "View your new home in Auburn, WA, through our photos. Explore floor plan interiors, amenities, & more. Take a look at The Verge's photos now!",
  "property_seo_title_virtualtours": "Virtual Tour | Auburn Apartments & Townhomes",
  "property_seo_description_virtualtours": "Discover your new home at The Verge! Take a virtual tour of our floor plans, amenities, & more. Start your tour now in Auburn, WA!",
  "property_seo_title_interactivemap": "Map | Apartments & Townhomes in North Dallas",
  "property_seo_description_interactivemap": "The Verge is located in Auburn, WA, near Main Street, Sounder commuter rail, & C St. View our map of our downtown Auburn apartments and townhomes!",
  "property_seo_title_neighborhood": "Neighborhood | Downtown Auburn Apartments & Townhomes ",
  "property_seo_description_neighborhood": "The Verge is located in Auburn, WA, near Main Street, Sounder commuter rail, & C St. Come in for a tour of our downtown Auburn apartments and townhomes!",
  "property_seo_title_contact": "Contact Us | Auburn Apartments & Townhomes for Rent",
  "property_seo_description_contact": "Have questions about our Auburn apartments & townhomes or want to schedule a tour? Our amazing leasing team is ready to help! Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Auburn, Auburn",
  "property_seo_description_faqs": "Unlock a world of comfort and convenience at The Verge in Auburn, where modern living meets thoughtful amenities. From stylish one and two-bedroom floor plans to invigorating spaces like our Paw Spa and on-site car wash, every detail ensures a vibrant lifestyle. Have questions? Our FAQs page is your go-to resource for everything you need to know about our community and its unique offerings. Dive into the seamless blend of luxury and practicality at The Verge!",
  "property_seo_title_reviews": "Reviews | Apartments & Townhomes in Auburn, WA",
  "property_seo_description_reviews": "Explore feedback from residents of The Verge! Learn firsthand experiences and gain insights into our vibrant apartment & townhome community in Auburn, WA.",
  "property_seo_title_applynow": "Apply Now | Studio, 1, & 2 Bedroom Apartments & Townhomes ",
  "property_seo_description_applynow": "Apply online for our 1, 2, or 3-bedroom apartments and townhomes for rent in Auburn, WA. Complete the application today!",
  "property_seo_title_residentaccess": "Resident Access | Auburn Apartments & Townhomes for Rent",
  "property_seo_description_residentaccess": "With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service and pay your rent online. Log in to get started.",
  "property_seo_title_referafriend": "Refer a Friend | Apartments & Townhomes in Auburn, WA",
  "property_seo_description_referafriend": "Refer a friend to The Verge and both of you can enjoy fantastic perks. Spread the word!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments & Townhomes in Auburn, WA",
  "property_seo_description_scheduletour": "Ready to explore The Verge firsthand? Book a tour and uncover our amenities and studio, 1, & 2-bedroom apartments and townhomes in Auburn, WA!",
  "property_seo_title_privacy": "Privacy Policy | The Verge",
  "property_seo_description_privacy": "At The Verge in Auburn, your privacy matters. Dive into our transparent privacy policy to understand how we protect your personal information while you enjoy the vibrant community lifestyle. Your comfort and security are our top priority—read more today!",
  "property_seo_title_accessibility": "Website Accessibility | The Verge",
  "property_seo_description_accessibility": "\"At The Verge in Auburn, we champion digital inclusion and accessibility for all. Our commitment to a welcoming online experience ensures everyone can effortlessly navigate and engage with our community. Learn how we prioritize accessibility and create a space where everyone feels at home.\"",
  "property_seo_title_sitemap": "Sitemap | The Verge",
  "property_seo_description_sitemap": "\"Navigate your future home at The Verge in Auburn! Our comprehensive sitemap provides a clear pathway to amenities, floor plans, and community highlights, making it easy to envision your ideal living experience. Dive in now!\"",
  "property_seo_title_thankyou": "Thank You | Apartments & Townhomes in Auburn, WA",
  "property_seo_description_thankyou": "Thank you for your interest in The Verge. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pet Policy | Apartments in Auburn, Auburn",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293567595",
  "amenities": [
    {
      "id": "ec_96b6350b32c03539dda1251b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "89442781",
      "title": "Housekeeping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f0b9fcb2f96346f45c9887c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "89442780",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_285531eeb0e76988e8a39178",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "89442779",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_987b333ab3573524223916d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539456",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f6e29ca3f82fc60ba235e7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523553",
      "title": "Parking Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3d11f5e53b63519d377f666",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523549",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89ec90e2146415799bd130ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523550",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c9ed6ac0377eb5cdf737736",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523547",
      "title": "Theater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f3a144089b3bf2a22823f38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523545",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_401cdb4b85e75bc58e55bccc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523543",
      "title": "Bike Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64ca4f0b1a71f75d390edd12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88525132",
      "title": "Two Level Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d38a48d5421f147b19c7fa5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523540",
      "title": "Courtyard with Rockery Garden",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c429fabfc49583114257f02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523537",
      "title": "Rooftop Deck with BBQs, Fire Pits, and Outdoor TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_795bee55b2b485c59bc9e3ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523538",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86eeb303fa3c1aa93847a524",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523541",
      "title": "Fitness Center with Yoga Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db07d8d9b1a55962554baf92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539459",
      "title": "Guest Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c03f4cff25278b296c86b8cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539460",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d233f670642b79edabb25b43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539467",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2eaf74af3ea9bc93fd191df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523627",
      "title": "Resident Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf828fafb6f196a37b635cc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523628",
      "title": "Car Wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d36fc0e89eb176127e41b8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523629",
      "title": "Paw Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f8c4b41f505808a85665606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88586045",
      "title": "Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d4520b1d88582f49738a3ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "89442640",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a697b2a0e9c385d16fb4f77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "89442639",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42b4b028636cc1d1d54a150b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539440",
      "title": "Wheelchair Access*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84fbe3dc99c3b285efd0278c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539434",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b76410e5c3df53f0ecbb5187",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539423",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8b5c82082a50fcab048991c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88525142",
      "title": "Scenic Mount Rainier Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0a5c-13e2-772b-a3b4-6fefba523b16.webp",
      "amenity_image_media": {
        "alt_text": "Snow-capped mountain range with green trees in the foreground",
        "public_id": "019d0a5c-13e2-772b-a3b4-6fefba523b16",
        "storage_key": "property/6767906449164271/019d0a5c-13e2-772b-a3b4-6fefba523b16.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "View of Mount Rainier from rooftop deck",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2dee9c8d9aee65242febb051",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88525140",
      "title": "Walk-In Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0a5c-13e6-7446-908f-bb88e1695809.webp",
      "amenity_image_media": {
        "alt_text": "Empty walk-in closet with shelving.",
        "public_id": "019d0a5c-13e6-7446-908f-bb88e1695809",
        "storage_key": "property/6767906449164271/019d0a5c-13e6-7446-908f-bb88e1695809.webp",
        "width": 2048,
        "height": 3072
      },
      "amenity_image_alt_text": "Walk-in closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffd830d18dffb13dab4c9a4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88525137",
      "title": "Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ded6a6ae3529ecfa571b6fc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523631",
      "title": "Full-Size Front Load Washers/Dryers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0a5c-13c5-7601-bd9b-4842c475c0d5.webp",
      "amenity_image_media": {
        "alt_text": "Stackable Whirlpool washer and dryer unit.",
        "public_id": "019d0a5c-13c5-7601-bd9b-4842c475c0d5",
        "storage_key": "property/6767906449164271/019d0a5c-13c5-7601-bd9b-4842c475c0d5.webp",
        "width": 2048,
        "height": 3072
      },
      "amenity_image_alt_text": "Full-size front load washer and dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c49af2671710863d42eee2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523559",
      "title": "Private Balcony/Patio*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec6b3806a20f2d58caf43fe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523557",
      "title": "Energy-Efficient Stainless-Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d151b490f047ff109332b5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523558",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a36aa3a29d4772f2ee07597",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539421",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_341a53e254dea8d2c110f603",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539420",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3de36a6b828e9c0bd5f9d95b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539422",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_325934af5a3617d08a7efdcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539425",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_002379bb73387ba57cc6c7a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88539436",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b7973decc411569768f3f4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523632",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d20ac-373d-726b-a184-a5ff3d41500d.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wine glasses",
        "public_id": "019d20ac-373d-726b-a184-a5ff3d41500d",
        "storage_key": "property/6767906449164271/019d20ac-373d-726b-a184-a5ff3d41500d.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Kitchen island",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31c5a4c3f61d323d2265b027",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "88523633",
      "title": "Custom Self-Closing Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e64dd90b3bf0e519f5773ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "89442783",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_459934131afc833fdbd808b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "yardi",
      "external_id": "89442784",
      "title": "AC Port",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_7d0efc00732556a526de23fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "title": "Apartment",
      "description": "Stylish open-concept living space featuring a comfortable sofa, a chic coffee table, and a modern kitchen with a dining nook. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/36.jpg"
    },
    {
      "id": "ec_d13864d07fa343051a2abf0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e5a5-7500-9a25-5892e4bb13dd.webp",
      "image_media": {
        "alt_text": "Modern lounge with a fireplace and large windows overlooking mountains",
        "public_id": "019d0812-e5a5-7500-9a25-5892e4bb13dd",
        "storage_key": "property/6767906449164271/019d0812-e5a5-7500-9a25-5892e4bb13dd.webp",
        "width": 2560,
        "height": 1711
      },
      "title": "Community",
      "description": "Relax in our stylish community lounge, featuring a cozy fireplace and stunning mountain views.",
      "link": "false",
      "alt_text": "Modern lounge with a fireplace and large windows overlooking mountains",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/46.jpg"
    },
    {
      "id": "ec_35a26fc9876f98ecc51a36b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-f641-749a-b6ec-6dabb7437327.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a table overlooking a city street and a distant mountain.",
        "public_id": "019d0812-f641-749a-b6ec-6dabb7437327",
        "storage_key": "property/6767906449164271/019d0812-f641-749a-b6ec-6dabb7437327.webp",
        "width": 2498,
        "height": 1900
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on this private balcony, offering stunning views of the cityscape and a majestic mountain in the distance.",
      "link": "false",
      "alt_text": "Balcony with two chairs and a table overlooking a city street and a distant mountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/55.jpg"
    },
    {
      "id": "ec_9df943e595ef104a3bda9eda",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e705-7696-85c7-7358c3e14d7f.webp",
      "image_media": {
        "alt_text": "Rooftop terrace with lounge chairs, seating areas, and green spaces.",
        "public_id": "019d0812-e705-7696-85c7-7358c3e14d7f",
        "storage_key": "property/6767906449164271/019d0812-e705-7696-85c7-7358c3e14d7f.webp",
        "width": 2560,
        "height": 1671
      },
      "title": "Community",
      "description": "Enjoy the elevated outdoor living space on the rooftop terrace, complete with comfortable seating and lush greenery.",
      "link": "false",
      "alt_text": "Rooftop terrace with lounge chairs, seating areas, and green spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/23.jpg"
    },
    {
      "id": "ec_e9f68a62aded7ece3f03a79e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-f622-713a-8fc3-37e50cf0fa35.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with blue chairs and a white table.",
        "public_id": "019d0812-f622-713a-8fc3-37e50cf0fa35",
        "storage_key": "property/6767906449164271/019d0812-f622-713a-8fc3-37e50cf0fa35.webp",
        "width": 2560,
        "height": 1730
      },
      "title": "Apartment",
      "description": "Modern kitchen and dining area featuring sleek cabinetry, stainless steel appliances, and comfortable seating, perfect for entertaining or everyday meals.",
      "link": "false",
      "alt_text": "Kitchen and dining area with blue chairs and a white table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/33.jpg"
    },
    {
      "id": "ec_0dda00a72f5f80a93a615da6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-f662-77da-a34e-b1901610b97f.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and mountain view",
        "public_id": "019d0812-f662-77da-a34e-b1901610b97f",
        "storage_key": "property/6767906449164271/019d0812-f662-77da-a34e-b1901610b97f.webp",
        "width": 2560,
        "height": 1861
      },
      "title": "Community",
      "description": "Enjoy the breathtaking mountain views from our outdoor seating area, complete with a cozy fire pit, perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Outdoor seating area with fire pit and mountain view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/17.jpg"
    },
    {
      "id": "ec_95a8b9ef4d9cf0807bf7e543",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-f6af-720d-821e-be7723a185e5.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstands, and a walk-in closet.",
        "public_id": "019d0812-f6af-720d-821e-be7723a185e5",
        "storage_key": "property/6767906449164271/019d0812-f6af-720d-821e-be7723a185e5.webp",
        "width": 2551,
        "height": 1900
      },
      "title": "Apartment",
      "description": "A well-appointed bedroom featuring a comfortable bed, stylish decor, and ample closet space for all your storage needs.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, nightstands, and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/38.jpg"
    },
    {
      "id": "ec_586a31e626f3de9cc2708d10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-0417-77de-831a-4f1a66089d9c.webp",
      "image_media": {
        "alt_text": "Modern lounge area with blue armchairs, hexagonal coffee tables, and a high-top bar with stools.",
        "public_id": "019d0813-0417-77de-831a-4f1a66089d9c",
        "storage_key": "property/6767906449164271/019d0813-0417-77de-831a-4f1a66089d9c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating and a contemporary high-top bar area perfect for work or casual gatherings.",
      "link": "false",
      "alt_text": "Modern lounge area with blue armchairs, hexagonal coffee tables, and a high-top bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Verge Business Center 1.jpg"
    },
    {
      "id": "ec_089d69179385e8210d3a6979",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-03fd-7777-84d4-75eecbbb65c6.webp",
      "image_media": {
        "alt_text": "Exterior courtyard and buildings of a modern multifamily apartment complex.",
        "public_id": "019d0813-03fd-7777-84d4-75eecbbb65c6",
        "storage_key": "property/6767906449164271/019d0813-03fd-7777-84d4-75eecbbb65c6.webp",
        "width": 2560,
        "height": 1606
      },
      "title": "Community",
      "description": "Enjoy the vibrant community atmosphere with this stunning courtyard, surrounded by modern apartment buildings offering a unique urban living experience.",
      "link": "false",
      "alt_text": "Exterior courtyard and buildings of a modern multifamily apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/28.jpg"
    },
    {
      "id": "ec_e80730dd2801ddc65522733b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-046f-706a-b9f7-57f4cc4bfd3d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and wood cabinetry.",
        "public_id": "019d0813-046f-706a-b9f7-57f4cc4bfd3d",
        "storage_key": "property/6767906449164271/019d0813-046f-706a-b9f7-57f4cc4bfd3d.webp",
        "width": 2560,
        "height": 1769
      },
      "title": "Apartment",
      "description": "Step into this stunning kitchen featuring sleek white countertops, ample wood cabinetry, and modern stainless steel appliances. Perfect for culinary enthusiasts.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and wood cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/48.jpg"
    },
    {
      "id": "ec_66a5a5ec45f3e491d3f6e778",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-088f-7794-9f3d-15c7c0cf7633.webp",
      "image_media": {
        "alt_text": "Modern fitness center with cardio machines, weight machines, and rowing machines.",
        "public_id": "019d0813-088f-7794-9f3d-15c7c0cf7633",
        "storage_key": "property/6767906449164271/019d0813-088f-7794-9f3d-15c7c0cf7633.webp",
        "width": 2560,
        "height": 1475
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a wide range of cardio and strength training equipment to meet all your workout needs.",
      "link": "false",
      "alt_text": "Modern fitness center with cardio machines, weight machines, and rowing machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Fitness Center (4).jpg"
    },
    {
      "id": "ec_b1db2cc10e519ebf9c5868b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-1122-702a-b7aa-d4e2fb20e8e8.webp",
      "image_media": {
        "alt_text": "Outdoor grills and seating area on a rooftop patio.",
        "public_id": "019d0813-1122-702a-b7aa-d4e2fb20e8e8",
        "storage_key": "property/6767906449164271/019d0813-1122-702a-b7aa-d4e2fb20e8e8.webp",
        "width": 2560,
        "height": 1619
      },
      "title": "Community",
      "description": "Enjoy outdoor grilling and relaxing on the rooftop patio, perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Outdoor grills and seating area on a rooftop patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/57.jpg"
    },
    {
      "id": "ec_5d4dd7200ca036e9a0284c3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-140f-76ed-b1d4-ca8f0a593aa6.webp",
      "image_media": {
        "alt_text": "Communal lounge with sofas, foosball table, arcade games, and seating areas.",
        "public_id": "019d0813-140f-76ed-b1d4-ca8f0a593aa6",
        "storage_key": "property/6767906449164271/019d0813-140f-76ed-b1d4-ca8f0a593aa6.webp",
        "width": 2560,
        "height": 1805
      },
      "title": "Community",
      "description": "Enjoy the spacious and modern communal lounge featuring comfortable seating, a foosball table, and arcade games. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "Communal lounge with sofas, foosball table, arcade games, and seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Game Room (2).jpg"
    },
    {
      "id": "ec_0d987899466910e358485c5b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-140f-76ed-b1d4-c7b0ee614ae6.webp",
      "image_media": {
        "alt_text": "Theater room with plush recliners and a large screen.",
        "public_id": "019d0813-140f-76ed-b1d4-c7b0ee614ae6",
        "storage_key": "property/6767906449164271/019d0813-140f-76ed-b1d4-c7b0ee614ae6.webp",
        "width": 2560,
        "height": 1414
      },
      "title": "Community",
      "description": "Enjoy movie nights in our state-of-the-art theater room, complete with comfortable recliners and a big screen for an immersive cinematic experience.",
      "link": "false",
      "alt_text": "Theater room with plush recliners and a large screen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Theater.jpg"
    },
    {
      "id": "ec_3a5a6c7d80e130002244f763",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-16c8-76ca-b7c5-8f59f828f299.webp",
      "image_media": {
        "alt_text": "Modern home office with a desk, chair, record player, and artwork.",
        "public_id": "019d0813-16c8-76ca-b7c5-8f59f828f299",
        "storage_key": "property/6767906449164271/019d0813-16c8-76ca-b7c5-8f59f828f299.webp",
        "width": 2560,
        "height": 1705
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this modern home office, featuring a comfortable desk and chair, a vintage record player, and inspiring artwork on the walls.",
      "link": "false",
      "alt_text": "Modern home office with a desk, chair, record player, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/32.jpg"
    },
    {
      "id": "ec_13c29277eab11e34ac10df02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-2366-7332-b785-38687d91246e.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior at dusk with illuminated windows.",
        "public_id": "019d0813-2366-7332-b785-38687d91246e",
        "storage_key": "property/6767906449164271/019d0813-2366-7332-b785-38687d91246e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience modern urban living in this stunning apartment building, featuring stylish architecture and beautifully lit interiors.",
      "link": "false",
      "alt_text": "Modern apartment building exterior at dusk with illuminated windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Verge NE Corner.jpg"
    },
    {
      "id": "ec_4a6ce65a56210e92d90c356c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-20c3-73c9-99a2-2965f760b4be.webp",
      "image_media": {
        "alt_text": "Community cinema room with bar seating and a kitchenette.",
        "public_id": "019d0813-20c3-73c9-99a2-2965f760b4be",
        "storage_key": "property/6767906449164271/019d0813-20c3-73c9-99a2-2965f760b4be.webp",
        "width": 2302,
        "height": 1900
      },
      "title": "Community",
      "description": "Enjoy movie nights or gatherings in this stylish community cinema room, complete with comfortable bar seating and a convenient kitchenette.",
      "link": "false",
      "alt_text": "Community cinema room with bar seating and a kitchenette.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Theater Area (1).jpg"
    },
    {
      "id": "ec_e150bf0dfe5335e51fa1a629",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-2329-76a8-a6e4-5ffac82416a5.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with mixed materials and balconies.",
        "public_id": "019d0813-2329-76a8-a6e4-5ffac82416a5",
        "storage_key": "property/6767906449164271/019d0813-2329-76a8-a6e4-5ffac82416a5.webp",
        "width": 2560,
        "height": 1569
      },
      "title": "Community",
      "description": "Exterior view of a contemporary apartment building showcasing a blend of modern design elements, brick accents, and private balconies. Features street-level retail and parking entrance.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with mixed materials and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/9.jpg"
    },
    {
      "id": "ec_8ce5d2fac2c5abe7587c3a90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-235d-74f5-9f33-24162f5d3128.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, toilet, and bathtub with shower curtain.",
        "public_id": "019d0813-235d-74f5-9f33-24162f5d3128",
        "storage_key": "property/6767906449164271/019d0813-235d-74f5-9f33-24162f5d3128.webp",
        "width": 2560,
        "height": 1843
      },
      "title": "Apartment",
      "description": "Refresh and unwind in this beautifully appointed bathroom, featuring a spacious double vanity, modern fixtures, and a relaxing bathtub/shower combo.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, large mirror, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/42.jpg"
    },
    {
      "id": "ec_c30ef28ea71e98691331b4c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-2e48-70db-86ed-5332bd30855d.webp",
      "image_media": {
        "alt_text": "Modern lobby with a fireplace, seating, and a reception desk.",
        "public_id": "019d0813-2e48-70db-86ed-5332bd30855d",
        "storage_key": "property/6767906449164271/019d0813-2e48-70db-86ed-5332bd30855d.webp",
        "width": 2560,
        "height": 1696
      },
      "title": "Community",
      "description": "Welcome to our modern community lobby, featuring a cozy fireplace and comfortable seating areas.",
      "link": "false",
      "alt_text": "Modern lobby with a fireplace, seating, and a reception desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Lobby (1).jpg"
    },
    {
      "id": "ec_32278ada813711bff4cb2a1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-2f45-7262-890d-4af503c61e33.webp",
      "image_media": {
        "alt_text": "Exterior view of The Verge apartments, featuring modern architecture with brick and dark grey siding, balconies, and street-level retail.",
        "public_id": "019d0813-2f45-7262-890d-4af503c61e33",
        "storage_key": "property/6767906449164271/019d0813-2f45-7262-890d-4af503c61e33.webp",
        "width": 2560,
        "height": 1840
      },
      "title": "Community",
      "description": "Discover modern urban living at The Verge, showcasing stylish architecture, private balconies, and convenient street-level amenities. Experience a vibrant community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of The Verge apartments, featuring modern architecture with brick and dark grey siding, balconies, and street-level retail.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/10.jpg"
    },
    {
      "id": "ec_a381fcc4b5374f25c1c33a58",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-31c5-732d-8cf0-8d0c4d056afc.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, gray bedding, decorative pillows, and artwork on the wall.",
        "public_id": "019d0813-31c5-732d-8cf0-8d0c4d056afc",
        "storage_key": "property/6767906449164271/019d0813-31c5-732d-8cf0-8d0c4d056afc.webp",
        "width": 2560,
        "height": 1818
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-size bed and tasteful decor.",
      "link": "false",
      "alt_text": "Modern bedroom with a queen-size bed, gray bedding, decorative pillows, and artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/39.jpg"
    },
    {
      "id": "ec_3a0d35371e314d80db879067",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-31b7-76df-9ae5-d3c70a69894b.webp",
      "image_media": {
        "alt_text": "Modern wellness room with nature mural, TV, and fitness equipment.",
        "public_id": "019d0813-31b7-76df-9ae5-d3c70a69894b",
        "storage_key": "property/6767906449164271/019d0813-31b7-76df-9ae5-d3c70a69894b.webp",
        "width": 2560,
        "height": 1492
      },
      "title": "Community",
      "description": "Stay active in our modern wellness room, featuring a scenic nature mural, a large TV for entertainment, and exercise equipment like Bosu balls and step platforms.",
      "link": "false",
      "alt_text": "Modern wellness room with nature mural, TV, and fitness equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Yoga Room(1).jpg"
    },
    {
      "id": "ec_342241c96da4d8142c3285f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-3b72-703b-89c2-a5d3658bf97b.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen and living area with stainless steel appliances, white cabinets, and a sofa.",
        "public_id": "019d0813-3b72-703b-89c2-a5d3658bf97b",
        "storage_key": "property/6767906449164271/019d0813-3b72-703b-89c2-a5d3658bf97b.webp",
        "width": 2560,
        "height": 1680
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment featuring a fully equipped kitchen with stainless steel appliances and ample cabinet space, seamlessly flowing into a comfortable living area.",
      "link": "false",
      "alt_text": "Modern apartment kitchen and living area with stainless steel appliances, white cabinets, and a sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Open 1 Kitchen.jpg"
    },
    {
      "id": "ec_1667f02db0ecaaa84ecbf9ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-3cb5-73ec-bd04-f76ee5454d27.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen and dining area with wood ceilings and a TV.",
        "public_id": "019d0813-3cb5-73ec-bd04-f76ee5454d27",
        "storage_key": "property/6767906449164271/019d0813-3cb5-73ec-bd04-f76ee5454d27.webp",
        "width": 2560,
        "height": 1656
      },
      "title": "Community",
      "description": "Enjoy a stylish communal space with a fully equipped kitchen, ample dining seating, and a large screen TV for entertainment.",
      "link": "false",
      "alt_text": "Modern communal kitchen and dining area with wood ceilings and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/09.jpg"
    },
    {
      "id": "ec_dd4a6f2827bd215bbd54289b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-3ebc-7249-bb7a-2144d44b5b28.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and a fireplace.",
        "public_id": "019d0813-3ebc-7249-bb7a-2144d44b5b28",
        "storage_key": "property/6767906449164271/019d0813-3ebc-7249-bb7a-2144d44b5b28.webp",
        "width": 2560,
        "height": 1530
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge, featuring plush seating and a cozy fireplace.",
      "link": "false",
      "alt_text": "Modern lounge area with comfortable seating and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Hideaway (1).jpg"
    },
    {
      "id": "ec_34f82244d967d4632e781dbd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-401d-711c-8320-dac039389588.webp",
      "image_media": {
        "alt_text": "Hallway with elevators and doors on Level 5",
        "public_id": "019d0813-401d-711c-8320-dac039389588",
        "storage_key": "property/6767906449164271/019d0813-401d-711c-8320-dac039389588.webp",
        "width": 2560,
        "height": 1671
      },
      "title": "Community",
      "description": "Modern apartment hallway on Level 5 featuring elevators, contemporary carpet, and accent walls.",
      "link": "false",
      "alt_text": "Hallway with elevators and doors on Level 5",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/52.jpg"
    },
    {
      "id": "ec_0912977f761739f63e7957ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-661f-777d-818c-340b5b9d114f.webp",
      "image_media": {
        "alt_text": "Downtown Auburn Archway with street view and buildings",
        "public_id": "019d0813-661f-777d-818c-340b5b9d114f",
        "storage_key": "property/6767906449164271/019d0813-661f-777d-818c-340b5b9d114f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Downtown Auburn, a vibrant community featuring modern apartment buildings and lively streetscapes.",
      "link": "false",
      "alt_text": "Downtown Auburn Archway with street view and buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Auburn Sign.jpg"
    },
    {
      "id": "ec_4d851940a440e4836582e7ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0a5c-13e2-772b-a3b4-6fefba523b16.webp",
      "image_media": {
        "alt_text": "Snow-capped mountain range with green trees in the foreground",
        "public_id": "019d0a5c-13e2-772b-a3b4-6fefba523b16",
        "storage_key": "property/6767906449164271/019d0a5c-13e2-772b-a3b4-6fefba523b16.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Other",
      "description": "Majestic snow-capped mountain range towering over a lush green forest, offering a stunning natural landscape view.",
      "link": "false",
      "alt_text": "Snow-capped mountain range with green trees in the foreground",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Auburn Rainier 4.jpg"
    },
    {
      "id": "ec_b120fd4519818b85dff3cf7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0813-4cb6-7297-a7ee-98b7044c7605.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with sink and faucet, overlooking large windows with mountain view.",
        "public_id": "019d0813-4cb6-7297-a7ee-98b7044c7605",
        "storage_key": "property/6767906449164271/019d0813-4cb6-7297-a7ee-98b7044c7605.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Sleek kitchen island featuring a contemporary sink and faucet, complemented by expansive windows offering a breathtaking mountain vista.",
      "link": "false",
      "alt_text": "Modern kitchen island with sink and faucet, overlooking large windows with mountain view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Kitchen Rainier HDR (updated).jpg"
    },
    {
      "id": "ec_a38774c266fe5b349310c9b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0a5c-13c5-7601-bd9b-4842c475c0d5.webp",
      "image_media": {
        "alt_text": "Stackable Whirlpool washer and dryer unit.",
        "public_id": "019d0a5c-13c5-7601-bd9b-4842c475c0d5",
        "storage_key": "property/6767906449164271/019d0a5c-13c5-7601-bd9b-4842c475c0d5.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Convenient in-unit stackable Whirlpool washer and dryer.",
      "link": "false",
      "alt_text": "Stackable Whirlpool washer and dryer unit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Washer_Dryer closet.jpg"
    },
    {
      "id": "ec_fd73048399f7b1db29eba140",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0a5c-13e6-7446-908f-bb88e1695809.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelving.",
        "public_id": "019d0a5c-13e6-7446-908f-bb88e1695809",
        "storage_key": "property/6767906449164271/019d0a5c-13e6-7446-908f-bb88e1695809.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving, ready for your belongings.",
      "link": "false",
      "alt_text": "Empty walk-in closet with shelving.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Walk In Closet.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_72aea7c4-8d00-4f2b-aba4-297e737aad6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Boeing Auburn",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17-44 building, 700 15th St SW, Auburn, WA 98001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-229a-730c-a9da-fc8a1b8f291b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-229a-730c-a9da-fc8a1b8f291b",
        "storage_key": "property/6767906449164271/019dcfa4-229a-730c-a9da-fc8a1b8f291b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.boeing.com/contact-us.page",
      "poi_directions_map_url": "https://maps.google.com/?cid=17618317981517595196&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "boeing-auburn",
      "poi_latitude": "47.2888913",
      "poi_longitude": "-122.2422891",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-655-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8acf-75be-8486-d0313ea33338",
        "storage_key": "property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0qwXQhYkFQRPMI7vNvWgPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_3206d631-042e-459f-abb7-e27178acf5d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "MultiCare Auburn Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "202 N Division St, Auburn, WA 98001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d6cdf-0e15-77ba-b5e6-30d66ddbdb77.webp",
      "poi_featured_image_media": {
        "alt_text": "Emergency department check-in sign with arrows indicating directions for different patient types.",
        "public_id": "019d6cdf-0e15-77ba-b5e6-30d66ddbdb77",
        "storage_key": "property/6767906449164271/019d6cdf-0e15-77ba-b5e6-30d66ddbdb77.webp",
        "width": 1080,
        "height": 1920
      },
      "poi_business_url": "https://www.multicare.org/location/auburn-medical-center/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11639181374272454319&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "multicare-auburn-medical-center",
      "poi_latitude": "47.3091229",
      "poi_longitude": "-122.2292207",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-833-7711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-90b5-71e5-9afe-a1eeb2f4d16a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-90b5-71e5-9afe-a1eeb2f4d16a",
        "storage_key": "property/6767906449164271/019d0814-90b5-71e5-9afe-a1eeb2f4d16a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfXuti29YkFQRrz7a-cqthqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_1084847d-783e-44a8-aba2-e1823754584f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "PNW Coffee CO",
      "poi_type": "Restaurants",
      "poi_address": "110 2nd St SW #130, Auburn, WA 98001, USA",
      "poi_short_description": "Comfy cafe near the train station serving espresso-based drinks, baked items and breakfast items.",
      "poi_long_description": "People say this coffee shop offers delicious baked goods, breakfast burritos, and a variety of coffees and seasonal drinks. They highlight the cozy and inviting atmosphere, perfect for casual meetings or working, and the friendly and helpful staff. They also like the reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-1e16-77f7-9b2e-d46542b86d8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-1e16-77f7-9b2e-d46542b86d8f",
        "storage_key": "property/6767906449164271/019dcfa4-1e16-77f7-9b2e-d46542b86d8f.webp",
        "width": 926,
        "height": 617
      },
      "poi_business_url": "http://www.pnwcoffeeco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14979714271570594282&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pnw-coffee-co",
      "poi_latitude": "47.3062149",
      "poi_longitude": "-122.2313005",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-737-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-3a28-719f-bbf5-10a77a69bfa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcfa4-3a28-719f-bbf5-10a77a69bfa6",
        "storage_key": "property/6767906449164271/019dcfa4-3a28-719f-bbf5-10a77a69bfa6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ0ym7PklZkFQR6onQmcOi4s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_5188a9d6-bdd1-4e34-89c1-279d1fceb047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Rail Hop'n Brewing co and pizza",
      "poi_type": "Restaurants",
      "poi_address": "131 E Main St, Auburn, WA 98002, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-1f0a-7008-9fb2-33c5be03bb76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-1f0a-7008-9fb2-33c5be03bb76",
        "storage_key": "property/6767906449164271/019dcfa4-1f0a-7008-9fb2-33c5be03bb76.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.railhopn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3804875380660916772&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rail-hopn-brewing-co-and-pizza",
      "poi_latitude": "47.3075814",
      "poi_longitude": "-122.227347",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-217-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8acf-75be-8486-d0313ea33338",
        "storage_key": "property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPbHV0WVYkFQRJFLs5v-hzTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_1b59495a-3a1c-4685-9130-0208451fc805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Oddfellas Pub & Eatery Auburn",
      "poi_type": "Restaurants",
      "poi_address": "102 W Main St, Auburn, WA 98001, USA",
      "poi_short_description": "Taproom serving wraps, sandwiches, salads, burgers & hearty comfort food in a relaxed atmosphere.",
      "poi_long_description": "Diners like this pub's delicious and hearty food, with popular dishes including bangers and mash, schnitzel, and spinach dip, alongside a great selection of draft beers. They also highlight the friendly and attentive staff, the fun and comfortable pub-style atmosphere, and the excellent happy hour menu.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2039-723e-8b9a-b222bb57377d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2039-723e-8b9a-b222bb57377d",
        "storage_key": "property/6767906449164271/019dcfa4-2039-723e-8b9a-b222bb57377d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.oddfellaspubauburn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3308216190167525582&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oddfellas-pub--eatery-auburn",
      "poi_latitude": "47.3071991",
      "poi_longitude": "-122.2312706",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-939-7278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-3a29-70d7-919f-3643eeb8b614.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcfa4-3a29-70d7-919f-3643eeb8b614",
        "storage_key": "property/6767906449164271/019dcfa4-3a29-70d7-919f-3643eeb8b614.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt13eK25YkFQRzqgh5xgl6S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_f2af9c2e-b000-4b62-a15b-0e757dc99a3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Cow & Cod",
      "poi_type": "Restaurants",
      "poi_address": "201 A St SE, Auburn, WA 98002, USA",
      "poi_short_description": "Hamburger joint serving burgers, seafood, and shakes for dine-in or through the drive-thru.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious fish and chips, burgers, onion rings, and milkshakes. They also highlight the generous portions, reasonable prices, and friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-1e60-7314-a5e9-7e0806a016fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-1e60-7314-a5e9-7e0806a016fc",
        "storage_key": "property/6767906449164271/019dcfa4-1e60-7314-a5e9-7e0806a016fc.webp",
        "width": 1280,
        "height": 885
      },
      "poi_business_url": "https://cowandcod.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9373316230778437728&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cow--cod",
      "poi_latitude": "47.30536559999999",
      "poi_longitude": "-122.2289085",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-939-0341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8694-7490-9c00-c455edf2077c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8694-7490-9c00-c455edf2077c",
        "storage_key": "property/6767906449164271/019d0814-8694-7490-9c00-c455edf2077c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzfIrnFYkFQRYMDzLnO1FII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_5a34dd7d-8de8-463f-9f8f-5c7a5e3ac9c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Zola's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "402 E Main St #120, Auburn, WA 98002, USA",
      "poi_short_description": "Neighborhood coffee shop offering espresso, baked goods & paninis, including gluten-free options.",
      "poi_long_description": "Diners like this cafe's delicious coffee, breakfast burritos, and paninis, with many vegan and vegetarian options available. They also highlight the pleasant atmosphere, reasonable prices, and friendly staff.\n\nSome reviews mention the food can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2350-71be-806c-cc2d64b5ab46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2350-71be-806c-cc2d64b5ab46",
        "storage_key": "property/6767906449164271/019dcfa4-2350-71be-806c-cc2d64b5ab46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.joe.coffee/zolas-cafe",
      "poi_directions_map_url": "https://maps.google.com/?cid=14272822496977902840&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "zolas-cafe",
      "poi_latitude": "47.307475",
      "poi_longitude": "-122.2239823",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-333-9652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-3a28-719f-bbf5-10a77a69bfa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcfa4-3a28-719f-bbf5-10a77a69bfa6",
        "storage_key": "property/6767906449164271/019dcfa4-3a28-719f-bbf5-10a77a69bfa6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7dYhk3pYkFQR-FySunBAE8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_856e2422-8b1a-4fa8-b42a-3f15d945ea64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Rainbow Cafe",
      "poi_type": "Restaurants",
      "poi_address": "112 E Main St, Auburn, WA 98002, USA",
      "poi_short_description": "Mom-&-pop eatery serving hearty American favorites, including all-day breakfast, in comfy surrounds.",
      "poi_long_description": "Diners like this cafe's delicious and hearty breakfast options, including omelets, pancakes, and country-fried steak, with generous portions. They also highlight the friendly and attentive staff, reasonable prices, and clean, welcoming atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-224b-7117-84f7-952f1416114c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-224b-7117-84f7-952f1416114c",
        "storage_key": "property/6767906449164271/019dcfa4-224b-7117-84f7-952f1416114c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.rainbowcafediner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8096833940191065425&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rainbow-cafe",
      "poi_latitude": "47.3072611",
      "poi_longitude": "-122.2282217",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-833-1880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8694-7490-9c00-c455edf2077c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8694-7490-9c00-c455edf2077c",
        "storage_key": "property/6767906449164271/019d0814-8694-7490-9c00-c455edf2077c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhx0iGHBYkFQRUTVq2pG7XXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_1ec33d98-0205-42b5-bd9c-a8ec66714f59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Spunky Monkey Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "124 2nd St SE, Auburn, WA 98002, USA",
      "poi_short_description": "Casual haunt serving burgers & bar fare, known for its energetic karaoke nights.",
      "poi_long_description": "People say this bar and grill offers delicious food, including tasty burgers, fries, and wings, alongside a wide selection of drinks. They also highlight the fun and lively atmosphere, with karaoke every night, pool tables, and a supportive crowd.\n\nSome reviews mention the security can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-337e-74da-bbee-387c5b2e9654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-337e-74da-bbee-387c5b2e9654",
        "storage_key": "property/6767906449164271/019dcfa4-337e-74da-bbee-387c5b2e9654.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.spunkymonkeybarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13535149545143817022&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spunky-monkey-bar--grill",
      "poi_latitude": "47.3055673",
      "poi_longitude": "-122.227654",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-804-9567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-3a29-70d7-919f-3643eeb8b614.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcfa4-3a29-70d7-919f-3643eeb8b614",
        "storage_key": "property/6767906449164271/019dcfa4-3a29-70d7-919f-3643eeb8b614.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXf5VnBYkFQRPlMWjMyC1rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_91a63036-9744-4b8e-8d30-e9e421edf032",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Gor Gai Thai Street Food",
      "poi_type": "Restaurants",
      "poi_address": "614 E Main St, Auburn, WA 98002, USA",
      "poi_short_description": "Modern, easygoing eatery preparing traditional Thai street food, including noodle & rice dishes.",
      "poi_long_description": "Modern, easygoing eatery preparing traditional Thai street food, including noodle & rice dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-1f82-757a-96a6-85275f03da87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-1f82-757a-96a6-85275f03da87",
        "storage_key": "property/6767906449164271/019dcfa4-1f82-757a-96a6-85275f03da87.webp",
        "width": 1280,
        "height": 366
      },
      "poi_business_url": "http://gorgaithai.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3621879109759886631&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gor-gai-thai-street-food",
      "poi_latitude": "47.3074825",
      "poi_longitude": "-122.2214015",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-455-7177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8694-7490-9c00-c455edf2077c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8694-7490-9c00-c455edf2077c",
        "storage_key": "property/6767906449164271/019d0814-8694-7490-9c00-c455edf2077c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJywV7AHtYkFQRJ2WlXNx_QzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_342db4bd-cccb-4bd2-a5ff-c9e4a7de5f6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "762 Outlet Collection Way, Auburn, WA 98001, USA",
      "poi_short_description": "Big-box chain selling groceries, clothing, housewares and more, plus free grocery pickup.",
      "poi_long_description": "Some shoppers say this department store offers a wide variety of products and groceries, and they appreciate the friendly and helpful staff.\n\nOther reviews mention the checkout lines can be long and items can be locked up, requiring assistance from staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2164-731a-b122-1dc64fce70e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2164-731a-b122-1dc64fce70e3",
        "storage_key": "property/6767906449164271/019dcfa4-2164-731a-b122-1dc64fce70e3.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2385-auburn-wa/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3825427783124748851&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "47.3017207",
      "poi_longitude": "-122.240719",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-735-1855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8676-7071-b6e4-2094cfa050a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8676-7071-b6e4-2094cfa050a2",
        "storage_key": "property/6767906449164271/019d0814-8676-7071-b6e4-2094cfa050a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv0D-YwlYkFQRM4oP_0ymFjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_03b8be59-5d14-4a18-af31-53a0c4a52886",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "The Outlet Collection Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "1101 Outlet Collection Way, Auburn, WA 98001, USA",
      "poi_short_description": "Large outlet mall featuring brand-name shops for fashion & home goods, plus eateries & kid rides.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including outlets and name brands. They also highlight the good deals and discounts, and the fun activities for kids and families.\n\nOther reviews mention the food court can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-4625-726b-92e3-a68a6ae0f330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-4625-726b-92e3-a68a6ae0f330",
        "storage_key": "property/6767906449164271/019d0814-4625-726b-92e3-a68a6ae0f330.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://outletcollectionseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17162083842743284899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-outlet-collection-seattle",
      "poi_latitude": "47.2980791",
      "poi_longitude": "-122.243676",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-833-1790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8676-7071-b6e4-2094cfa050a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8676-7071-b6e4-2094cfa050a2",
        "storage_key": "property/6767906449164271/019d0814-8676-7071-b6e4-2094cfa050a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZa-M3GBZkFQRozQvjFP4K-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_efd49572-7cb9-4d97-ae3d-cb23248b364c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 Auburn Wy N, Auburn, WA 98002, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "People say this grocery store is clean and well-stocked, with a wide selection of products including specialty foods. They also highlight the friendly and helpful staff, and appreciate the good prices and shopper's card points that can be used to save money on gas.\n\nSome reviews mention the customer service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-24f1-75fc-b2bf-e81476d38435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-24f1-75fc-b2bf-e81476d38435",
        "storage_key": "property/6767906449164271/019dcfa4-24f1-75fc-b2bf-e81476d38435.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/wa/auburn/auburn/701/00019?cid=loc_70100019_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150320034374343021&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "47.3152985",
      "poi_longitude": "-122.226381",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-931-5550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-87a9-7366-91ea-1fb7c5729194.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-87a9-7366-91ea-1fb7c5729194",
        "storage_key": "property/6767906449164271/019d0814-87a9-7366-91ea-1fb7c5729194.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxUMNmFYkFQRbdnB0YB2IeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_09477462-72cc-4d87-be4a-daedd20467a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 Auburn Way S, Auburn, WA 98002, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Customers report that this grocery store provides good deals and prices on its app, along with a clean and well-stocked interior.\n\nOther reviews mention the staff can be unhelpful and even dismissive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-24ec-7122-bb5e-adbd3f39bbb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-24ec-7122-bb5e-adbd3f39bbb7",
        "storage_key": "property/6767906449164271/019dcfa4-24ec-7122-bb5e-adbd3f39bbb7.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://local.safeway.com/safeway/wa/auburn/101-auburn-way-s.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3155788417331406463&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "47.3063188",
      "poi_longitude": "-122.2274428",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-804-0138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-87a9-7366-91ea-1fb7c5729194.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-87a9-7366-91ea-1fb7c5729194",
        "storage_key": "property/6767906449164271/019d0814-87a9-7366-91ea-1fb7c5729194.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZX3fHBYkFQRf6ZUcdicyys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fd389e95-d89b-4a92-af77-ada9a49e8d75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Auburn Performing Arts Center A.P.A.C.",
      "poi_type": "Entertainment",
      "poi_address": "702 4th St NE, Auburn, WA 98002, USA",
      "poi_short_description": "School district's 1,100-seat theater hosting symphony, ballet & other performances.",
      "poi_long_description": "People say this performing arts center features a very good sound system, state-of-the-art lighting, and a large video screen backdrop for stage productions. Visitors also highlight the consistently clean and comfortable facility, with ample wheelchair-accessible seating. They also mention the professional and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-28f3-73ea-b4ea-3a47048d0cbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-28f3-73ea-b4ea-3a47048d0cbf",
        "storage_key": "property/6767906449164271/019dcfa4-28f3-73ea-b4ea-3a47048d0cbf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.auburn.wednet.edu/page/496",
      "poi_directions_map_url": "https://maps.google.com/?cid=1167478939243358802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "auburn-performing-arts-center-apac",
      "poi_latitude": "47.3096393",
      "poi_longitude": "-122.2202275",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-931-4827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8acf-75be-8486-d0313ea33338",
        "storage_key": "property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHXECCHtYkFQRUqpZ4Oi3MxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_1f9831ea-19cc-4980-8a11-5587aa1368bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Gosanko Chocolate - Factory",
      "poi_type": "Entertainment",
      "poi_address": "116 A St SE, Auburn, WA 98002, USA",
      "poi_short_description": "Confectionery making customized gourmet chocolates & offerings for holidays & special occasions.",
      "poi_long_description": "Confectionery making customized gourmet chocolates & offerings for holidays & special occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2e3d-743d-a726-dc90eedc4341.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2e3d-743d-a726-dc90eedc4341",
        "storage_key": "property/6767906449164271/019dcfa4-2e3d-743d-a726-dc90eedc4341.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gosankochocolate.com/?utm_source=gmb&utm_medium=organic&utm_campaign=gosankogmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3617724029475894638&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gosanko-chocolate---factory",
      "poi_latitude": "47.3061973",
      "poi_longitude": "-122.2283109",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-333-7567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8676-7071-b6e4-2094cfa050a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8676-7071-b6e4-2094cfa050a2",
        "storage_key": "property/6767906449164271/019d0814-8676-7071-b6e4-2094cfa050a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaZpVT3BYkFQRbjVOWNa8NDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chocolate_shop"
    },
    {
      "id": "custom_e460345f-f0a1-4410-b687-9902ba564b08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "White River Amphitheatre",
      "poi_type": "Entertainment",
      "poi_address": "40601 Auburn Enumclaw Rd SE, Auburn, WA 98092, USA",
      "poi_short_description": "Open-air, summertime venue offering food, beverages & live music from popular artists.",
      "poi_long_description": "People say this concert venue offers great sound quality and a wide variety of food and drink options, including tasty choices. Visitors also highlight the clean restrooms, friendly staff, and the option for affordable lawn seating with good views.\n\nSome reviews mention the parking exit can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2715-76c1-83a1-782f599b8c42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2715-76c1-83a1-782f599b8c42",
        "storage_key": "property/6767906449164271/019dcfa4-2715-76c1-83a1-782f599b8c42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.whiteriveramphitheatre.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2439583702264618071&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "white-river-amphitheatre",
      "poi_latitude": "47.2373313",
      "poi_longitude": "-122.1117935",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-825-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8acf-75be-8486-d0313ea33338",
        "storage_key": "property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOxE--CXxkFQRV5xQpXMk2yE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_fe9741a0-b29a-4011-bad8-9c06909fbca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Muckleshoot Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "2402 Auburn Way S, Auburn, WA 98002, USA",
      "poi_short_description": "Sizable venue for table & video gaming, with dance club & several restaurants.",
      "poi_long_description": "People say this casino offers a wide selection of games, including slots, bingo, and table games, and has a non-smoking area. They also highlight the friendly and helpful staff, the clean and modern facilities, and the convenient parking garage.\n\nOther reviews mention the payouts can be low.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2714-70ec-b158-24e45f82b2e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2714-70ec-b158-24e45f82b2e9",
        "storage_key": "property/6767906449164271/019dcfa4-2714-70ec-b158-24e45f82b2e9.webp",
        "width": 869,
        "height": 828
      },
      "poi_business_url": "http://muckleshootcasino.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15493663948618381064&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "muckleshoot-casino-resort",
      "poi_latitude": "47.2909623",
      "poi_longitude": "-122.1966087",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 800-804-4944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8acf-75be-8486-d0313ea33338",
        "storage_key": "property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFbodq873kFQRCLestkWNBNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_30390e2c-f52a-4fb3-aa78-f797a6e6a3dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Emerald Downs",
      "poi_type": "Entertainment",
      "poi_address": "2300 Ron Crockett Dr, Auburn, WA 98001, USA",
      "poi_short_description": "This horse racing center offers track level & grandstand seats, dining options & special activities.",
      "poi_long_description": "People say this race course offers fun horse races, as well as other races like corgi and dinosaur races. They highlight the beautiful view of Mount Rainier, the variety of food and drink options, and the availability of shaded seating. They also like the family-friendly atmosphere and the helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-28fc-72b8-a656-fd0975758189.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-28fc-72b8-a656-fd0975758189",
        "storage_key": "property/6767906449164271/019dcfa4-28fc-72b8-a656-fd0975758189.webp",
        "width": 728,
        "height": 409
      },
      "poi_business_url": "http://www.emeralddowns.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2732059951622409140&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "emerald-downs",
      "poi_latitude": "47.3282377",
      "poi_longitude": "-122.2373605",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-288-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8acf-75be-8486-d0313ea33338",
        "storage_key": "property/6767906449164271/019d0814-8acf-75be-8486-d0313ea33338.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJReC_dVdYkFQRtEuGCQ066iU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_fbec11ce-b747-401b-8a43-bb2138222a25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Green River College",
      "poi_type": "Education",
      "poi_address": "12401 SE 320th St, Auburn, WA 98092, USA",
      "poi_short_description": "Main campus of public two-year college offering transfer degrees, career training & continuing ed.",
      "poi_long_description": "Main campus of public two-year college offering transfer degrees, career training & continuing ed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2b4d-777e-b80b-7a9a816723d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2b4d-777e-b80b-7a9a816723d0",
        "storage_key": "property/6767906449164271/019dcfa4-2b4d-777e-b80b-7a9a816723d0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.greenriver.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2982264991200524603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "green-river-college",
      "poi_latitude": "47.3131581",
      "poi_longitude": "-122.1785746",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-833-9111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8674-73dc-bcfe-386796e01e08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8674-73dc-bcfe-386796e01e08",
        "storage_key": "property/6767906449164271/019d0814-8674-73dc-bcfe-386796e01e08.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqwojRaBYkFQROzmXcjUiYyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d371fe33-6a69-4238-9f2e-58d2c8eaa29e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Auburn Riverside High School",
      "poi_type": "Education",
      "poi_address": "501 Oravetz Rd SE, Auburn, WA 98092, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2945-75de-870d-6e7a71df7573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2945-75de-870d-6e7a71df7573",
        "storage_key": "property/6767906449164271/019dcfa4-2945-75de-870d-6e7a71df7573.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auburn.wednet.edu/ARHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=5654366401291378395&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "auburn-riverside-high-school",
      "poi_latitude": "47.2674251",
      "poi_longitude": "-122.2224411",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-804-5154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8674-73dc-bcfe-386796e01e08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8674-73dc-bcfe-386796e01e08",
        "storage_key": "property/6767906449164271/019d0814-8674-73dc-bcfe-386796e01e08.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk9ODdin3kFQR217gqkhYeE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f0dc1ff7-b6d4-4f7a-ac01-5814a5fb3b84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Auburn Mountainview High School",
      "poi_type": "Education",
      "poi_address": "28900 124th Ave SE, Auburn, WA 98092, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-298e-777f-97f0-4b57dda33743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-298e-777f-97f0-4b57dda33743",
        "storage_key": "property/6767906449164271/019dcfa4-298e-777f-97f0-4b57dda33743.webp",
        "width": 392,
        "height": 276
      },
      "poi_business_url": "http://www.auburn.wednet.edu/Domain/10",
      "poi_directions_map_url": "https://maps.google.com/?cid=17130123349132400900&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "auburn-mountainview-high-school",
      "poi_latitude": "47.3419907",
      "poi_longitude": "-122.1719807",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-804-4539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8674-73dc-bcfe-386796e01e08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8674-73dc-bcfe-386796e01e08",
        "storage_key": "property/6767906449164271/019d0814-8674-73dc-bcfe-386796e01e08.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH3-eMzNfkFQRBFmpP21suu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_88e55f9a-1d7a-4205-a038-75696c73cc2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Lakeland Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "1020 Evergreen Way SE, Auburn, WA 98092, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2b58-77ae-bc7b-77393f0de458.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2b58-77ae-bc7b-77393f0de458",
        "storage_key": "property/6767906449164271/019dcfa4-2b58-77ae-bc7b-77393f0de458.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auburn.wednet.edu/Domain/25",
      "poi_directions_map_url": "https://maps.google.com/?cid=5815023037816289315&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lakeland-hills-elementary-school",
      "poi_latitude": "47.2543536",
      "poi_longitude": "-122.2155243",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-876-7711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-8674-73dc-bcfe-386796e01e08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8674-73dc-bcfe-386796e01e08",
        "storage_key": "property/6767906449164271/019d0814-8674-73dc-bcfe-386796e01e08.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeSWIhtX5kFQRI7jAwaQcs1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_16eafc5f-8fbf-466e-baa1-acd03086fb80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Game Farm Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3030 R St SE, Auburn, WA 98002, USA",
      "poi_short_description": "Park with a playground & walking trail, plus facilities for softball, soccer, tennis & basketball.",
      "poi_long_description": "People say this park offers a variety of sports fields and courts, including soccer, baseball, tennis, and pickleball, as well as walking trails, a disc golf course, and river access. They highlight the new bridge connecting the park to a wilderness area, providing scenic views and extended exercise opportunities. They also like the well-lit tennis courts, which are open late, and the clean and well-maintained grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d6ce0-8f1b-7097-8086-97c4652ca675.webp",
      "poi_featured_image_media": {
        "alt_text": "Soccer field with players practicing at dusk, illuminated by stadium lights.",
        "public_id": "019d6ce0-8f1b-7097-8086-97c4652ca675",
        "storage_key": "property/6767906449164271/019d6ce0-8f1b-7097-8086-97c4652ca675.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12772272286572327046&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "game-farm-park",
      "poi_latitude": "47.2810232",
      "poi_longitude": "-122.2035778",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-931-3043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-90b4-71ca-ba4a-64632e04e431.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-90b4-71ca-ba4a-64632e04e431",
        "storage_key": "property/6767906449164271/019d0814-90b4-71ca-ba4a-64632e04e431.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcXbyb73kFQRhrC1Z_k5QLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c2421402-dd3b-4f45-af2c-df967873e40c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Les Gove Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "910 9th St SE, Auburn, WA 98002, USA",
      "poi_short_description": "City park offers 20 acres of walking trails, a playground & by-the-hour cottage rentals.",
      "poi_long_description": "City park offers 20 acres of walking trails, a playground & by-the-hour cottage rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2d8e-705a-b270-46c34d3f301e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2d8e-705a-b270-46c34d3f301e",
        "storage_key": "property/6767906449164271/019dcfa4-2d8e-705a-b270-46c34d3f301e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.auburnwa.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=17493235691373649972&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "les-gove-park",
      "poi_latitude": "47.298969",
      "poi_longitude": "-122.216328",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-931-3043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-90b4-71ca-ba4a-64632e04e431.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-90b4-71ca-ba4a-64632e04e431",
        "storage_key": "property/6767906449164271/019d0814-90b4-71ca-ba4a-64632e04e431.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYymiitf3kFQRNOCCnC11xPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7fd29ca7-006a-4972-af9f-0016e55be7b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "McCollum Park Forest Loop Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 128th St SE, Everett, WA 98208, USA",
      "poi_short_description": "Acreage featuring a paved path, picnic benches, a playground and a closed swimming pool.",
      "poi_long_description": "Visitors say this park offers a beautiful, easy nature trail that's perfect for walking, running, or biking, and they praise the abundance of mushrooms and fall colors. They also highlight that it's a great place for dogs, with plenty of grassy areas for them to play and a clean, wide trail that's easy to navigate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-3106-75a9-a55c-3cae28a21586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-3106-75a9-a55c-3cae28a21586",
        "storage_key": "property/6767906449164271/019dcfa4-3106-75a9-a55c-3cae28a21586.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3571252142978741034&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mccollum-park-forest-loop-trail",
      "poi_latitude": "47.8783833",
      "poi_longitude": "-122.2241509",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-388-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-90b4-71ca-ba4a-64632e04e431.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-90b4-71ca-ba4a-64632e04e431",
        "storage_key": "property/6767906449164271/019d0814-90b4-71ca-ba4a-64632e04e431.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcUZm5EGkFQRKrOZGeeijzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_610fa4bc-c784-47d1-aaee-076653a67277",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Green River Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "37215 188th Ave SE, Auburn, WA 98092, USA",
      "poi_short_description": "Scenic riverside trails for hiking, biking and horseback riding in a park-like setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019dcfa4-2fc6-754b-ba4f-610b71fcccee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcfa4-2fc6-754b-ba4f-610b71fcccee",
        "storage_key": "property/6767906449164271/019dcfa4-2fc6-754b-ba4f-610b71fcccee.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://kingcounty.gov/en/dept/dnrp/nature-recreation/parks-recreation/king-county-parks/natural-working-lands/green-river-natural-area",
      "poi_directions_map_url": "https://maps.google.com/?cid=7738987788797866643&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "green-river-natural-area",
      "poi_latitude": "47.2682709",
      "poi_longitude": "-122.0918886",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-477-4527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-90b4-71ca-ba4a-64632e04e431.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-90b4-71ca-ba4a-64632e04e431",
        "storage_key": "property/6767906449164271/019d0814-90b4-71ca-ba4a-64632e04e431.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYuJHp72kFQRk_JhGGRoZms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c3978517-e65d-4665-adc8-d45e1b068f6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "poi_name": "Washington National Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14330 SE Husky Way, Auburn, WA 98092, USA",
      "poi_short_description": "Collegiate golf course boasting a signature 18th hole with a purple “W” insignia, plus an events venue.",
      "poi_long_description": "Golfers say this golf course has a challenging course design with plenty of bunkers and contoured greens, and they appreciate the UW branding on the carts. They also highlight the friendly and helpful staff, and the fair prices for a great time.\n\nSome reviews mention the bunkers can be in poor condition due to rocks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-719c-75b8-adb1-f104b2bb0783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-719c-75b8-adb1-f104b2bb0783",
        "storage_key": "property/6767906449164271/019d0814-719c-75b8-adb1-f104b2bb0783.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://washingtonnationalgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5449797838894313536&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "washington-national-golf-club",
      "poi_latitude": "47.3078928",
      "poi_longitude": "-122.1502665",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-333-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0814-90b8-75ff-9bf9-f5404f939b4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-90b8-75ff-9bf9-f5404f939b4f",
        "storage_key": "property/6767906449164271/019d0814-90b8-75ff-9bf9-f5404f939b4f.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xM4Mw72kFQRQLD8nEKSoUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    }
  ],
  "office_hours": [
    {
      "id": "ec_0c861a9da419b2b39d305f34",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4a73f0fffcc20ff66c45b782",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e589ed5eb80425442d9b8bd7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_56fb4b2d27c3d3ae665c27c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_ad44fac53d86c654b23f5633",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5c36c7a06142838853301c10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_bf8ed27991e871693855cf18",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "rating": "5",
      "name": "Eric Weiler",
      "text": "The Verge gets a 5 out of 5 stars from me.  I'd give it a 10 if I could.   My wife and I are moving in within a few weeks and the staff at the Verge could not have been any more accommodating.  Their leasing specialist Dasha and Hannah are very knowledgable and extremely helpful.  We toured the property and it has everything you could ever want and more.  They keep up the property and when we asked a few residents who lived there, both had been there since opening and said it was the best place they'd ever lived.  I would recommend the Verge to anyone.",
      "date": "2025-12-10",
      "title": "false"
    },
    {
      "id": "ec_9c5fa6063a39c4552968acf5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "rating": "5",
      "name": "Amora T-Lopez",
      "text": "I've been living here for about 6 months with my fiancé and we love it here. We LOVE taking advantage of the movie theater room they have downstairs. It's so much fun. The workout room is certainly one of my favorites. It certainly does feel like you're living in a high class place and I absolutely love it. The rooftop is absolutely one of my favorite places. It's exactly as pictured. Mt. Rainier is STUNNING! A literal dream come true. In case if anyone is wondering what a standard 1 Bedroom looks like at this place, I took the liberty of taking pictures of my place.\nI didn't take too many pictures of our bedroom because we're still settling in lol! But the bedroom has a nice walk-in closet (Only took a picture of the door to give you a sense of where it is. Not taking a picture of the inside that's weird lol). There is a washer and dryer behind the door of the bathroom. It's certainly interesting but I like it.\nRegarding the bad review that Jacob put, I'd like to say that this place does NOT stink of dog urine or marijuana. I've not run into any of those issues. The apartment comes with a parking garage so I don't know why he's saying that he had to pay \"hundreds of dollars\" to park blocks away. I honestly don't know the office staff but they seem nice. I talked to them a couple of times and they've met my needs. The elevator literally works completely fine. \"Standing there and repeatedly pushing the buttons so they can work\" is absolutely an over-exaggeration 1000%! They work like any other elevator. Plus, we've got stairs to use too. The walls and floors are not paper thin. I've lived in a uni dorm for 4 years to know about paper thin walls. Sure, I can hear foot steps and people moving things here and there but it's not obnoxious. Yes, the trains are loud but they don't shake the whole building XD At least not in my experience. Honestly, I sleep with a fan on every night to help me sleep and I never hear any trains in the middle of the night. Occasionally, here and there I may hear a train or two in the middle of the night when I'm already awake but it's not crazy loud enough to disturb anyone during their sleep UNLESS you chose to sleep with your windows open, which I do not recommend. All in all, these place is very nice. Like any apartment you WILL run into some issues here and there. For us, we had a kid that kept pounding on our door and ran every night but once I told the staff about it, it stopped. Every apartment will come with their cons but honestly, we have not run into any super annoying issues while living here. It's a very nice place to live! 5 stars all the way!",
      "date": "2025-05-01",
      "title": "false"
    },
    {
      "id": "ec_a67580218720fee7400cc760",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "rating": "5",
      "name": "Antone Simas",
      "text": "Honestly I don’t know why this place doesn’t have higher reviews. I lived in the area for over a year. I love the downtown Auburn area. It’s close to everything and the downtown area has soo many fun activities. I always saw the Verge on my drive to my old apartment.  After taking a tour the place has sooo many amenities that I haven’t found anywhere else. Car wash, dog wash, rooftop, theater, vending machine *NEW*, plenty of meeting areas, courtyard, everything is app based, too many things to list! They really do offer a lot.\n\nThe move in process was great! The staff has been very accommodating and welcoming, they even reserve you an elevator for your move in. I received a welcome gift on my first day. I've only been here a couple weeks and they already had fun activities for the residents including free baked goods!  Thanks for making me feel welcome. Honestly have not been here long but really excited to be here and happy to have stayed in the Auburn area.",
      "date": "2025-10-02",
      "title": "false"
    },
    {
      "id": "ec_4bcc297f75e7d6e6240a933d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "rating": "5",
      "name": "Saurabh Bhatt",
      "text": "I love this place! As one of the first tenants of The Verge, we had lots of questions and their team (especially Gabby and Emma) helped us patiently.\nThis is a new construction and the space is well made with modern design. Apartments have huge windows and ample light and ventilation. I love the amenities including outdoor spaces, spacious gym, theater (yes, a theater!) and much more.\nEven with all the amenities, their management is the best feature of this apartment. They are empathetic and always quick to help out. They even surprised me with a birthday card and gift (Thank you!).\n\nThe only downside, which is minor for us is the train honks. We use white noise machine and that works like a charm.\n\nI totally recommend this place!",
      "date": "2021-06-08",
      "title": "false"
    },
    {
      "id": "ec_bc480bf1262c57f69c1415ca",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "rating": "5",
      "name": "LaMesha Antoine",
      "text": "I lived in this complex for about 2 years. and relocated out of state for work late August 2024. This is my experience while living here.\n\nInitial move in: Completed the application and got approved in minutes. I did have to pay a holding deposit, but I got back when I moved out. They do have carts to use but buy your own cart/wagon and keep in your car as they get used a lot.\n\nCleanliness: The property was very clean. Some pets would have accidents, but tenets would generally clean up after them. They did have cleaners at the complex daily from what I can remember.\n\nAmenities: They have a party room/game room that has a full kitchen and fireplace you can rent for the day, a patio, a gym, some study nooks, movie theater, dog and car wash station. The only amenities missing was a sauna and a pool. The gym did have free weights, cardio machines, and a yoga room, but not barbells. No pet park but there is a field on the northeast side (if its still there). They offer reserved parking for a price in the garage attached to the building (if you can try to request one not next to a column lol). I did get a tow notice once while parked in my assign parking spot towards the end off my lease, but that was an accident since their systems calculated the wrong move out date haha. I'm just happy that they knew me well enough to reach out and confirm before calling a tow company lol. No central air but there is central heat and central air and heat in the hallways. Internet is built into the unit so no need to have a router and modem. You had the option to have centurylink/quantum fiber and another company. The electricity was never too crazy or over 100 dollars for me with PSE. This is a very secure building. I do like that you need to have a key fob to get into the building and the elevators so not everyone could get in. So if you do have guest, you will have to meet them in the lobby.\n\nStaff: Elizabeth, Emma, Hannah and the maintenance crew were wonderful and very attentive to any issue I had. Maintenance request could be done in the portal or by emailing the team. Most request were completed within the same day. When I needed to extend my lease by one week because my movers cancelled last minute among other things, they were willing to work with me on such short notice even though they didn't have to. The staff always hosted an event every month or bi-weekly along with free coffee in the lobby daily.\n\nTenants: Everyone from different walks of life. A very mixed community. No loud kids or parties, but every now and then there would be marijuana smell in the hallways. Mind you this is labeled as a smoke free apartment complex, but some tenets do not adhere to it. No designated smoking area, just make sure you're more than 25 feet from the door. I think they made it a rule now that you have to go across the street to smoke. Although I lived on the top floor, people would slam their doors a lot. But people also generally keep to themselves but are very nice.\n\nArea: The complex is right across from the train station and it shares a line with freight trains and Amtrak. This Sounder train will take you into downtown Seattle while also stopping at other cities along the way, but only in the early mornings and after 2 or 3pm. There is a Safeway, grocery outlet and couple of local eateries, wine bar, a 7-11 and coffee shop/cafe all within walking distance. It is a very walkable area.\n\nNoise: The train is all hours of the day and night, but its not too bad once you get use to it. Work from home? Get noise cancelling headphones.  There is an annoyance of people driving in the train parking garage at night doing burnouts. Not often, but it does happen.  The hospital and city hall as well as the police station is a couple blocks down the street so be prepared for police and ambulance sightings. Rarely you would hear someone yelling in the streets after midnight. Other than that, it is pretty quiet.\n\nAll in all I would stay here again if I ever moved back to the area. Its safe, clean, and quiet, more quiet than being in downtown Seattle.",
      "date": "2025-11-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b44734ad-97b9-46ca-8263-9bba2bf6b37a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019defce-1793-703e-b125-d43a0a151b0c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019defce-1793-703e-b125-d43a0a151b0c",
        "storage_key": "property/6767906449164271/019defce-1793-703e-b125-d43a0a151b0c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "701 (C8 – Two Bedroom)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QDvCh9UMLG3&guides=0&play=1&qs=1&ts=1&lp=1&dh=0"
    },
    {
      "id": "custom_e643708f-b7cf-4a01-9806-2c0426838cb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019defce-a749-775a-ab67-72bc51c2bb9d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019defce-a749-775a-ab67-72bc51c2bb9d",
        "storage_key": "property/6767906449164271/019defce-a749-775a-ab67-72bc51c2bb9d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "705 (A9 Studio)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MytBdVK5Z4K&guides=0&play=1&qs=1&ts=1&lp=1&dh=0"
    },
    {
      "id": "custom_6fe08325-1006-4632-aefe-f4c2d00d1ce3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019defcf-a47a-768e-858e-e99c75d30100.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019defcf-a47a-768e-858e-e99c75d30100",
        "storage_key": "property/6767906449164271/019defcf-a47a-768e-858e-e99c75d30100.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "707 (A4.2 Open One Bedroom)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dxUJdaCXMWT&guides=0&play=1&qs=1&ts=1&lp=1&dh=0"
    },
    {
      "id": "custom_f145061b-9681-45d8-8372-c868c198cef8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019defcf-ea40-7629-8f26-b5bf569bfa1b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019defcf-ea40-7629-8f26-b5bf569bfa1b",
        "storage_key": "property/6767906449164271/019defcf-ea40-7629-8f26-b5bf569bfa1b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "724 (A1 Studio)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KGJMWkgM9g6&guides=0&play=1&qs=1&ts=1&lp=1&dh=0"
    },
    {
      "id": "custom_20f54acc-ee77-43b0-93e4-7a81823c9797",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019defd0-2648-70e9-80b7-d4734c42526c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019defd0-2648-70e9-80b7-d4734c42526c",
        "storage_key": "property/6767906449164271/019defd0-2648-70e9-80b7-d4734c42526c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "725 (B1 One Bedroom)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=G8DZwTS1Sro&guides=0&play=1&qs=1&ts=1&lp=1&dh=0"
    },
    {
      "id": "custom_d12ee00b-bdf5-465b-8df8-80d517934a3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019defd0-6390-72b6-a4ba-c8e5b077bb1d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019defd0-6390-72b6-a4ba-c8e5b077bb1d",
        "storage_key": "property/6767906449164271/019defd0-6390-72b6-a4ba-c8e5b077bb1d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "626 (B6 One Bedroom + Den)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DhRGn4VoFyr&guides=0&play=1&qs=1&ts=1&lp=1&dh=0"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa4b-8f32-716a-a6c5-f63274836a30",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-verge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271"
    },
    {
      "lead_collector_id": "0198aa4b-8f96-7347-96b1-5facbcc24e72",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-verge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271"
    },
    {
      "lead_collector_id": "0198aa4b-8ffa-76e5-ba21-2196c4aa9e87",
      "lead_source": "LANDING_PAGE",
      "name": "the-verge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-auburn-wa-verge",
      "search_query": "pet friendly apartments in Auburn WA",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Auburn, WA",
      "h2_subtitle": "Discover pet-friendly living at The Verge in Auburn, WA. Enjoy modern amenities tailored for you and your furry friend.",
      "page_copy": "Embrace a pet-friendly lifestyle at The Verge in Auburn, WA. Our community is perfect for you and your furry family members, with amenities designed to cater to pet owners. Start your day at our on-site Paw Spa before taking a stroll around our manicured grounds.\n\nThe Verge offers luxurious pet-friendly apartments in Auburn, WA, with studio, one, and two-bedroom floor plans. Each unit features modern amenities such as quartz countertops and custom cabinets, ensuring both comfort and style. Explore availability today and find a home where you and your pet can thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Auburn, WA",
      "seo_description": "Explore pet-friendly apartments in Auburn, WA at The Verge. Modern living with amenities like a Paw Spa. Find your ideal home today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "high-speed-internet-apartments-king-county-verge",
      "search_query": "apartments with high speed internet in King County",
      "category": "Amenity",
      "h1_title": "Apartments with High Speed Internet",
      "h2_subtitle": "Discover apartments with high-speed internet in King County at The Verge. Experience seamless connectivity in a modern living space.",
      "page_copy": "At The Verge in Auburn, find apartments equipped with high-speed internet, perfect for those in King County seeking seamless connectivity. Our community ensures that staying connected is easy and convenient, whether for work or leisure.\n\nBeyond high-speed internet, The Verge offers stylish studio, one, and two-bedroom apartments featuring quartz countertops and custom cabinets. Enjoy additional amenities such as resident package lockers and electric car charging stations. Explore our availability today and enjoy modern living tailored to your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "King County Apartments with High Speed Internet",
      "seo_description": "Find King County apartments with high-speed internet at The Verge. Enjoy modern amenities and seamless connectivity. Explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "car-charging-stations-auburn-apartment-verge",
      "search_query": "car charging stations Auburn apartment",
      "category": "Amenity",
      "h1_title": "Car Charging Stations at Auburn Apartments",
      "h2_subtitle": "Discover Auburn apartments with car charging stations at The Verge. Enjoy modern amenities and eco-friendly living combined.",
      "page_copy": "The Verge in Auburn offers apartments with convenient car charging stations, perfect for eco-conscious residents. Our location provides the perfect blend of sustainability and modern living, making it a top choice for those driving electric vehicles.\n\nIn addition to car charging stations, The Verge features stylish studio, one, and two-bedroom floor plans equipped with high-end amenities like quartz countertops and custom self-closing cabinets. Enjoy a community that caters to every need, including those who are environmentally conscious. Check availability and discover your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Auburn Apartments with Car Charging Stations",
      "seo_description": "Explore The Verge in Auburn, offering apartments with car charging stations. Modern, eco-friendly living awaits. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "luxury-apartments-quartz-countertops-auburn-verge",
      "search_query": "luxury apartments with quartz countertops in Auburn",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Quartz Countertops",
      "h2_subtitle": "Experience luxury living with quartz countertops at The Verge in Auburn. Discover stylish apartments designed for modern comfort.",
      "page_copy": "Discover luxury living at The Verge in Auburn, where apartments feature stunning quartz countertops. These high-end finishes are just the beginning of the upscale living experience awaiting you here. Each unit boasts designer details complemented by modern amenities.\n\nThe Verge offers a selection of studio, one, and two-bedroom luxury apartments with quartz countertops, custom cabinetry, and more. Our community also includes resident package lockers and state-of-the-art car charging stations, ensuring every aspect of modern life is covered. Schedule a tour today and find the perfect blend of elegance and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Quartz Countertops in Auburn",
      "seo_description": "Explore luxury apartments with quartz countertops in Auburn at The Verge. Experience high-end finishes and modern conveniences. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "apartment-ac-port-near-98001-verge",
      "search_query": "apartment with air conditioning port near 98001",
      "category": "Amenity",
      "h1_title": "Apartment with AC Port Near 98001",
      "h2_subtitle": "Find an apartment with an AC port near 98001 at The Verge. Enjoy a comfortable living environment with modern conveniences.",
      "page_copy": "At The Verge, located near the 98001 area, find your ideal apartment equipped with an air conditioning port. Perfect for those warm Auburn days, our apartments provide a comfortable and convenient lifestyle. \n\nChoose from a range of floor plans including stylish studio, one, and two-bedroom layouts that meet your needs. Besides the AC ports, enjoy upscale amenities like quartz countertops, custom cabinets, and car charging stations. Our community is designed with your comfort in mind. Check out our availability today and experience modern living at its best.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with AC Port Near 98001",
      "seo_description": "Discover an apartment with an AC port near 98001 at The Verge. Enjoy modern amenities and comfort today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-auburn-wa-verge",
      "search_query": "one bedroom apartments auburn wa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Auburn, WA",
      "h2_subtitle": "Explore one bedroom apartments in Auburn, WA at The Verge. Enjoy stylish living with modern amenities designed for convenience.",
      "page_copy": "Explore the comfortable and stylish one bedroom apartments at The Verge in Auburn, WA. Our one-bedroom units offer the perfect blend of modern design and convenience, complete with quartz countertops and custom self-closing cabinets.\n\nResidents enjoy access to an array of amenities such as car charging stations, resident package lockers, and a Paw Spa, all contributing to a hassle-free lifestyle. Discover all that one bedroom living at The Verge can offer. Schedule a visit today and experience urban comfort in a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Auburn, WA",
      "seo_description": "Discover stylish one bedroom apartments in Auburn, WA at The Verge. Enjoy modern living with top-notch amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "studio-apartments-king-county-verge",
      "search_query": "studio apartments king county",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in King County",
      "h2_subtitle": "Discover studio apartments in King County at The Verge. Experience modern living with top-notch amenities in a friendly community.",
      "page_copy": "Located in King County, The Verge offers beautiful studio apartments designed for a contemporary lifestyle. Embrace the open layout complemented by luxurious features such as quartz countertops and custom self-closing cabinets.\n\nOur community delivers more than just stylish living spaces. Enjoy the convenience of resident package lockers, a Paw Spa, and car charging stations. Ideal for those wanting urban flair with practical amenities, our studio apartments make living in King County an extraordinary experience. Visit us to explore your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in King County",
      "seo_description": "Explore modern studio apartments in King County at The Verge. Enjoy stylish spaces with top amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-98001-verge",
      "search_query": "two bedroom apartments near 98001",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 98001",
      "h2_subtitle": "Discover spacious two bedroom apartments near 98001 at The Verge. Modern amenities and comfortable living await you.",
      "page_copy": "The Verge offers expansive two bedroom apartments conveniently located near the 98001 area. These modern apartments feature elegant quartz countertops and custom self-closing cabinets, perfect for those seeking sophistication and convenience.\n\nResidents benefit from an array of amenities designed to enhance daily living, including car charging stations, resident package lockers, and a dedicated Paw Spa. Experience a blend of style and practicality in a vibrant community. Visit The Verge today to find your ideal two-bedroom home near Auburn's thriving heart.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 98001",
      "seo_description": "Find spacious two bedroom apartments near 98001 at The Verge. Enjoy modern amenities in a prime location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "apartments-near-green-river-college-auburn-verge",
      "search_query": "apartments near green river college auburn",
      "category": "School",
      "h1_title": "Apartments Near Green River College Auburn",
      "h2_subtitle": "Explore apartments near Green River College in Auburn at The Verge. Enjoy modern living with convenient access to campus.",
      "page_copy": "Discover the perfect place to call home at The Verge, conveniently located near Green River College in Auburn. Choose from studio, one, or two-bedroom apartment options that boast contemporary finishes like quartz countertops and custom self-closing cabinets.\n\nOur community offers more than just exceptional living spaces. Residents can take advantage of practical amenities including resident package lockers, car charging stations, and a Paw Spa, making life at The Verge not only comfortable but incredibly convenient. Schedule a tour and see what makes our apartments the ideal choice for students and faculty alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Green River College, Auburn",
      "seo_description": "Find stylish apartments near Green River College in Auburn at The Verge. Enjoy easy access and modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "apartments-near-multicare-auburn-medical-center",
      "search_query": "apartments near MultiCare Auburn Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near MultiCare Auburn Medical Center",
      "h2_subtitle": "Find comfortable apartments near MultiCare Auburn Medical Center at The Verge. Enjoy modern amenities in a convenient location.",
      "page_copy": "The Verge offers beautifully designed apartments located just a short distance from MultiCare Auburn Medical Center. Choose from a selection of studio, one, or two-bedroom apartments, all featuring modern touches like quartz countertops and custom cabinets.\n\nOur community provides residents with a range of convenient amenities, including resident package lockers, car charging stations, and a Paw Spa. Whether you're a healthcare professional or someone who values proximity to quality medical care, The Verge is the ideal spot offering both comfort and convenience. Explore our availability today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MultiCare Auburn Medical Center",
      "seo_description": "Discover modern apartments near MultiCare Auburn Medical Center at The Verge. Enjoy top amenities and a prime location. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "apartments-close-to-virginia-mason-federal-way-urgent-care",
      "search_query": "apartments close to Virginia Mason Federal Way Urgent Care King County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Virginia Mason Federal Way",
      "h2_subtitle": "Experience modern living in apartments close to Virginia Mason Federal Way Urgent Care. The Verge offers convenience in King County.",
      "page_copy": "Situated near Virginia Mason Federal Way Urgent Care in King County, The Verge provides the perfect blend of convenience and style. Choose from studio, one, or two-bedroom apartments, each featuring stunning quartz countertops and custom self-closing cabinets that enhance your living experience.\n\nEnjoy an array of community amenities designed for modern living, including resident package lockers, car charging stations, and a Paw Spa for pet lovers. Living at The Verge means being minutes away from essential healthcare services while enjoying a comfortable lifestyle. Discover affordable luxury here today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Virginia Mason Federal Way",
      "seo_description": "Find stylish apartments near Virginia Mason Federal Way Urgent Care at The Verge, in King County. Explore our amenities and prime location today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "apartments-near-lake-tapps-park-auburn-verge",
      "search_query": "apartments near Lake Tapps Park Auburn",
      "category": "Park",
      "h1_title": "Apartments Near Lake Tapps Park Auburn",
      "h2_subtitle": "Enjoy living near Lake Tapps Park in Auburn at The Verge. Discover our stylish and comfortable apartments just minutes away.",
      "page_copy": "Nestled in Auburn, The Verge offers fantastic apartments conveniently located near the tranquil Lake Tapps Park. Our selection of studio, one, or two-bedroom floor plans provides residents with modern amenities such as quartz countertops and custom self-closing cabinets.\n\nThe Verge is more than just stylish interiors; it’s a community brimming with practical features like resident package lockers and car charging stations. Plus, with a Paw Spa on-site, pet enthusiasts will feel right at home. Experience living close to nature’s beauty while enjoying the vibrant lifestyle here at The Verge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lake Tapps Park Auburn",
      "seo_description": "Live close to Lake Tapps Park in Auburn at The Verge. Explore our modern apartments with convenient amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "apartments-close-to-game-farm-park-king-county",
      "search_query": "apartments close to Game Farm Park King County",
      "category": "Park",
      "h1_title": "Apartments Close to Game Farm Park",
      "h2_subtitle": "Explore modern apartments close to Game Farm Park in King County. The Verge offers stylish living in a prime location.",
      "page_copy": "The Verge is the ultimate choice for those seeking well-designed apartments close to Game Farm Park in King County. With options ranging from studio to two-bedroom layouts, all units are equipped with lavish quartz countertops and custom self-closing cabinets, perfect for modern living.\n\nThis community boasts amenities like resident package lockers, car charging stations, and even a Paw Spa for pet owners. The Verge not only provides proximity to the natural beauty of Game Farm Park but also ensures every comfort and convenience is at your fingertips. Discover your ideal home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Game Farm Park",
      "seo_description": "Find modern apartments near Game Farm Park in King County at The Verge. Enjoy exceptional amenities and a convenient location. Discover more today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164271",
      "source": "generator",
      "page_item_url": "apartments-by-steel-lake-park-98001",
      "search_query": "apartments by Steel Lake Park 98001",
      "category": "Park",
      "h1_title": "Apartments by Steel Lake Park",
      "h2_subtitle": "Discover convenient apartments by Steel Lake Park in the 98001 zip code. The Verge offers stylish living with great amenities.",
      "page_copy": "Located near Steel Lake Park in the 98001 area, The Verge provides a perfect blend of convenience and sophistication. Choose from our array of studio, one, and two-bedroom apartments, each designed with custom self-closing cabinets and sleek quartz countertops, ideal for those who appreciate modern comforts.\n\nResidents at The Verge enjoy exceptional community features including car charging stations, resident package lockers, and a Paw Spa. Whether you’re taking a leisurely stroll by Steel Lake Park or relaxing in your modern home, The Verge stands out as a premier living destination. Find your new home with us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and view of kitchen with dining area.",
        "public_id": "019d0812-e6c8-7463-98ed-ece77aecdc87",
        "storage_key": "property/6767906449164271/019d0812-e6c8-7463-98ed-ece77aecdc87.webp",
        "width": 2560,
        "height": 1702
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Steel Lake Park",
      "seo_description": "Explore stylish apartments by Steel Lake Park in the 98001 area. The Verge offers modern living with great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4927"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9241077656"
    },
    {
      "ID": "custom_pay_rent_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MH5MLSFF"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/f7dc10d3-c9da-4296-92d8-93b896a4d4ce/app.js?property=f7dc10d3-c9da-4296-92d8-93b896a4d4ce&propertyName=The+Verge&channelUuid=c0a160b2-7c1c-11eb-8904-42010aa8d42b\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_id",
      "type": "STRING",
      "value": "l27vqk53vox"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "5641873213"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/l27vqk53vox"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "650-457-5961"
    },
    {
      "ID": "custom_seattle_income_limits_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjdyNUtlNFUvMEN0bXEvMXAwNGFCT2c9PSIsInZhbHVlIjoiditaTEYvbTdsZWJ5ZWp2Qm1jMWw5QT09IiwibWFjIjoiYWVhNjQ2OWUyYzg5YmEwZTBmNzUzNjMyOGU2NGIwYThjY2U4NTRjOTYyNDA2YTA1ZjIwZTg1YmM0OTU1MzY3ZSJ9"
    },
    {
      "ID": "custom_pillar_properties_guarantee",
      "type": "STRING",
      "value": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple."
    },
    {
      "ID": "custom_seattle_income_qualified_blurb",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_pillar_properties_screening_criteria",
      "type": "STRING",
      "value": "https://multihubmedia.com/company/5767906449162415/019db50d-a86b-7498-9bfc-90eac29a2820.pdf"
    },
    {
      "ID": "custom_pillar_properties_guarantee_disclaimer",
      "type": "STRING",
      "value": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "4927",
  "custom_repli_id": "9241077656",
  "custom_google_gtm_id": "GTM-MH5MLSFF",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/f7dc10d3-c9da-4296-92d8-93b896a4d4ce/app.js?property=f7dc10d3-c9da-4296-92d8-93b896a4d4ce&propertyName=The+Verge&channelUuid=c0a160b2-7c1c-11eb-8904-42010aa8d42b\" defer></script>",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_id": "l27vqk53vox",
  "custom_hubspot_company_id": "5641873213",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/l27vqk53vox",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "650-457-5961",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjdyNUtlNFUvMEN0bXEvMXAwNGFCT2c9PSIsInZhbHVlIjoiditaTEYvbTdsZWJ5ZWp2Qm1jMWw5QT09IiwibWFjIjoiYWVhNjQ2OWUyYzg5YmEwZTBmNzUzNjMyOGU2NGIwYThjY2U4NTRjOTYyNDA2YTA1ZjIwZTg1YmM0OTU1MzY3ZSJ9",
  "custom_pillar_properties_guarantee": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple.",
  "custom_pillar_properties_screening_criteria": "https://multihubmedia.com/company/5767906449162415/019db50d-a86b-7498-9bfc-90eac29a2820.pdf",
  "custom_pillar_properties_guarantee_disclaimer": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
};

export const generatedAt = '2026-11-02T22:33:47.673Z';
